var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 mw-100" },
    [
      _vm.dto.commonCta
        ? [
            _c("generic-button-cta", {
              attrs: {
                "css-classes": "w-100 mw-100 btn-primary",
                "dto-from-object": _vm.dto.commonCta,
                "is-disabled": _vm.isDisabled,
              },
            }),
          ]
        : _vm.dto.mobileCta
        ? [
            _vm.dto.mobileCta.popinWithDeviceDto
              ? _c("offer-cta-with-device-popin", {
                  staticClass: "mb-2",
                  attrs: {
                    "additional-classes": "w-100 mw-100",
                    "is-primary": true,
                    label: _vm.dto.mobileCta.label,
                    "offer-name": _vm.dto.name,
                    "popin-id": "addOfferWithDevicePopIn",
                    "popin-ctas-dto": _vm.dto.mobileCta.popinWithDeviceDto,
                    "tracking-category": "reprise_panier",
                    "tracking-label": "vers_popin",
                  },
                })
              : _c("ob1-boutons", {
                  attrs: {
                    "is-button": false,
                    "is-primary": true,
                    "is-wide": true,
                    "is-disabled": _vm.isDisabled,
                    label: _vm.dto.mobileCta.label,
                    href: _vm.dto.mobileCta.link,
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }